import { createEffect, ofType, Actions } from "@ngrx/effects";
import {
  withLatestFrom,
  switchMap,
  map,
  catchError
} from "rxjs/operators";
import { Store } from "@ngrx/store";
import { DaveActions } from "../actions/actions";
import { HttpService } from "../../services/http.service";
import { State } from "../index";
import { QMStatusActionTypes } from "../actions/qMStatus.actions";
import { QMStatusEntityFromBackend } from "../../entities/qMStatus.entity";
import { BaseActionTypes } from "../actions/base.actions";
import { of } from "rxjs";
import { Injectable } from "@angular/core";

enum ErrorCodes {
  Load = "Status Abrufen fehlgeschlagen",
  Modify = "Status Bearbeiten fehlgeschlagen"
}

@Injectable()
export class QMStatusEffects {

  LoadQMStatus = createEffect(() => this.actions$.pipe(
    ofType(QMStatusActionTypes.GetQMStatusRequest),
    withLatestFrom(this.store$),
    switchMap(([action, store]) => {
      const queryString = `
    query{
    qmstatus{
      id
      name
      partnerId
    }
    }`
  ;
      return this.gatewayHttpService
        .graphQl({ query: queryString }, { token: store.base.token, retry: true })
        .pipe(
          map(res =>
            res && res.qmstatus
              ? QMStatusActionTypes.UpdateQMStatus({
                  Payload: res.qmstatus.map(val =>
                    QMStatusEntityFromBackend(val)
                  )
                })
              : BaseActionTypes.ErrorAction({
                  Payload: { ToasterMessage: ErrorCodes.Load }
                })
          ),
          catchError((err, caught) =>
            of(
              BaseActionTypes.ErrorAction({
                Payload: {
                  ToasterMessage: ErrorCodes.Load,
                  Err: err,
                  Caught: caught
                }
              })
            )
          )
        );
    })
  ));
  constructor(
    private actions$: Actions<DaveActions>,
    private store$: Store<State>,
    private gatewayHttpService: HttpService
  ) {}
}
